import { __decorate, __metadata } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { clearInterval, setInterval } from "worker-timers";
let Timer = /** @class */ (() => {
    var _a;
    let Timer = class Timer extends Vue {
        constructor() {
            super(...arguments);
            this.liveTimeInSeconds = 0;
            this.interval = 0;
        }
        get timerDisplay() {
            let date = new Date(0);
            date.setSeconds(!this.static ? this.liveTimeInSeconds : this.elapsedSeconds);
            return date.toISOString().substr(11, 8);
        }
        TimeInterval() {
            if (this.startTime != undefined) {
                const istOffset = 5 * 60 + 30; // IST offset in minutes
                const currentTimeInSeconds = Date.now();
                const startTimeInSeconds = new Date(this.startTime).getTime() + istOffset * 60 * 1000;
                const timeDifferenceInSeconds = (currentTimeInSeconds - startTimeInSeconds) / 1000;
                this.liveTimeInSeconds = timeDifferenceInSeconds;
            }
        }
        created() {
            this.TimeInterval();
            if (!this.static) {
                console.log("created at: " + new Date() + " with props set at: " + this.elapsedSeconds);
                this.interval = setInterval(() => {
                    this.TimeInterval();
                }, 1000);
            }
        }
        destroyed() {
            clearInterval(this.interval);
            if (!this.static) {
                console.log("destroyed at: " + new Date() + " with internal time as : " + this.elapsedSeconds);
                clearInterval(this.interval);
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], Timer.prototype, "elapsedSeconds", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], Timer.prototype, "static", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
    ], Timer.prototype, "startTime", void 0);
    Timer = __decorate([
        Component
    ], Timer);
    return Timer;
})();
export default Timer;
